import React, { useState } from "react";
import { IoCloudDownload } from "react-icons/io5";
import { getData, postData, postDaqiData } from "../../store/utils.js";
import Swal from "sweetalert2";
import { saveAs } from "file-saver";
import FileUploadView from "../../component/FileUploadView.js";
import FileUploadPreview from "../../component/FileUploadPreview.js"; // Import new component

function BulkInventory() {
  const [file, setFile] = useState(null);
  const [error, setError] = useState("");
  const [csvPreview, setCsvPreview] = useState([]);
  const [isLoadingOn, setIsLoadingOn] = useState(false);
  const [showFileUploadView, setShowFileUploadView] = useState(true);
  const [csvData, setCsvData] = useState([]); // Store full CSV data
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10; // Number of rows per page

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];

    if (!selectedFile) {
      setError("No file selected. Please upload a file.");
      setFile(null);
      return;
    }

    const fileExtension = selectedFile.name.split(".").pop().toLowerCase();
    if (fileExtension !== "csv") {
      setError("Only .csv files are allowed.");
      setFile(null);
      return;
    } else {
      setError("");
    }

    // Read as text for CSV preview
    const textReader = new FileReader();
    textReader.onload = (event) => {
      const text = event.target.result;
      // const rows = text.split("\n").map((row) => row.split(","));
      // setCsvPreview(rows.slice(0, 5)); // Preview only first 5 rows
      const rows = text
      .trim()
      .split(/\r?\n/)
      .map(row => row.split(","))
      .filter(row => row.some(cell => cell.trim() !== "")); // Ensure at least one non-empty cell

      setCsvData([]);
      console.log("Parsed CSV Rows:", rows);
      console.log("Total Rows Before Filtering:", text.split(/\r?\n/).length);
      console.log("Total Rows After Filtering:", rows.length);

      setCsvData(rows); // Store full CSV data in state
      setCurrentPage(1); // Reset pagination to first page
    };
  
    textReader.onerror = () => {
      setError("Error reading file as text. Please try again.");
    };
  
    textReader.readAsText(selectedFile);
  
    // Read as Base64 for sending in POST request
    const base64Reader = new FileReader();
    base64Reader.onload = () => {
      const base64String = base64Reader.result.split(",")[1]; // Extract Base64 data
      setFile({ name: selectedFile.name, base64: base64String });
      console.log("Base64 CSV Data:", base64String); // Log Base64 data
      setShowFileUploadView(false);
    };
  
    base64Reader.onerror = () => {
      setError("Error reading file as Base64. Please try again.");
    };
  
    base64Reader.readAsDataURL(selectedFile);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!file) {
      setError("Please upload a valid .csv file.");
      return;
    }

    let tempDataSend = { file: file.base64 };
    setIsLoadingOn(true);
    const tempData = await postDaqiData(`inventory/bulkInventory`, tempDataSend);
    setIsLoadingOn(false);

    if (tempData.statusCode === 200) {
      Swal.fire({ icon: "success", title: "Success!", text: "CSV file successfully uploaded!" });
      setTimeout(() => window.location.reload(), 3000);
    } else {
      Swal.fire({ icon: "error", title: "Error!", text: tempData?.data?.errors?.msg || "Something went wrong" });
    }

    resetFile();
  };

  const resetFile = () => {
    setFile(null);
    setError("");
    setCsvPreview([]);
    setShowFileUploadView(true);
    document.getElementById("fileInput").value = "";
  };

  const downloadCSV = () => {
    saveAs("https://daqi-cdn-bucket.s3.ap-south-1.amazonaws.com/inventory/inventory-bulk-template.csv", "inventory-bulk-template.csv");
  };

  // Pagination Logic
  const totalPages = Math.ceil(csvData.length / rowsPerPage);
  const startIndex = (currentPage - 1) * rowsPerPage;
  const paginatedData = csvData.slice(startIndex, startIndex + rowsPerPage);

  return (
    <div className="row">
        <div className="d-flex">
          <h4>Inventory Bulk Upload</h4>
          <div className="ms-auto">
            <a onClick={downloadCSV} className="btn btn-link">Sample File</a>
          </div>
        </div>
        <div className="customHeaderTable" >
          <form onSubmit={handleSubmit} className="d-flex align-items-center gap-2">
            <div >
              <input
                className="form-control"
                placeholder="Click here to Upload Inventory File"
                type="file"
                id="fileInput"
                onChange={handleFileChange}
                accept=".csv"
              />
            </div>
            <button type="submit" className="btn btn-primary">Submit</button>
          </form>
          {error && <p style={{ color: "red" }}>{error}</p>}
        </div>

        {/* Show FileUploadView if no CSV file is uploaded */}
        <div className="customHeaderTable">
          {csvData.length > 0 ? (
            <>
              <h4>CSV Preview</h4>
              <FileUploadPreview csvPreview={csvData} />
            </>
          ) : (
            <FileUploadView />
          )}
        </div>
      </div>
  );
}

export default BulkInventory;